export default __webpack_public_path__ + "static/media/calendarImgSmall.119c5668.svg";